import { render, staticRenderFns } from "./TouristTaxes.vue?vue&type=template&id=01b7b8c0&"
import script from "./TouristTaxes.vue?vue&type=script&lang=js&"
export * from "./TouristTaxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports